import { render, staticRenderFns } from "./DriverHomeView.vue?vue&type=template&id=1f67fb9d&"
import script from "./DriverHomeView.vue?vue&type=script&lang=ts&"
export * from "./DriverHomeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports